<div class="row">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    @if (textFlag) {
      <div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center my-auto">
          <div class="card card-block d-flex" style="height: 120px">
            <div class="card-body align-items-center d-flex justify-content-center font-xl">
              {{'field.label.No_Terms_and_Conditions' | translate | async }}
            </div>
          </div>
        </div>
      </div>
    }
    @if (tmc!=undefined && tmc!='') {
      <div>
        {{tmc}}
      </div>
    }
    @if (doc_Flag) {
      <div>
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center my-auto">
          <div class="card card-block d-flex" style="height: 120px">
            <div class="card-body align-items-center d-flex justify-content-center font-xl">
              {{'field.label.No_Documents_Found' | translate | async }}
            </div>
          </div>
        </div>
      </div>
    }
    @if (documentIds.length > 0) {
      <div class="border" id="scrollsTestLab" [class]="showHistory?'col-12 col-sm-8 col-md-9':'col-12'">
        @if (documentIds.length > 1) {
          <div class="row d-flex mt-2" >
            <div class="col-6">
              <button id="arrow" class="btn btn-white cursor-pointer fa fa-arrow-left fa-lg butoon-small "
              style="color:rgb(82, 79, 79)" (click)="getDocumentId('left')"></button>
            </div>
            <div class="col-6">
              <button id="arrow"
                class="btn btn-white fa fa-arrow-right cursor-pointer fa-lg butoon-small float-right"
              style="color:rgb(82, 79, 79)" (click)="getDocumentId('right')"></button>
            </div>
          </div>
        }
        <hr>
          <ng-container [ngTemplateOutlet]="imageviewer">
          </ng-container>
        </div>
      }
      <ng-template #imageviewer>
        <ng-container>
          @if (blobResp && (blobResp.type == 'image/jpeg' || blobResp.type == 'image/png' || blobResp.type == 'image/jpg' || blobResp.type == 'image/gif')) {
            <div
              >
              <app-image-viewer style="width: 100%; height:600px" [src]="imageSrc" [fileData]="fileData">
              </app-image-viewer>
            </div>
          }
          @if (pdfDocument && blobResp && blobResp.type == 'application/pdf') {
            <div>
              <pdf-viewer [config]="pdfDocument" [isBlob]="true"></pdf-viewer>
            </div>
          }
          @if (blobResp && blobResp.type == 'text/plain') {
            <div>
              <div>
                <div style="margin-bottom: 1rem; font-weight: bold;">
                {{textFile.document_name ? textFile.document_name : ''}}</div>
                <div>{{decodedText ? decodedText : ''}}</div>
              </div>
            </div>
          }
          @if (blobResp && blobResp.type == 'application/dicom' && imageUrl != '') {
            <div>
              <diacom-viewer [config]="{url:imageUrl}"></diacom-viewer>
            </div>
          }
        </ng-container>
      </ng-template>
      @if ( gridContainer && type == 'table') {
        <div class="position-relative">
          <!-- [filterFieldGroup]="_currentData.currentFilterListFormFields" -->
          <dhs-data-grid [data]="gridContainer" [fields]="resource.list.fields"
            [filterFieldGroup]="_currentData.currentFilterListFormFields"
            [bulkActionsConfig]="resource.list.bulkAction" [config]="configList" (bindGrid)="bindDataToGrid($event)"
            (bulkActionClicked)="onBulkActionClicked($event)" (onLimitChange)="limitChanged($event)"
            (onFilterChange)="filterChange($event)" (onPageChanges)="pageChanges($event)"
            (editEllipseClick)="buttonAction($event)">
          </dhs-data-grid>
        </div>
      }
      <!-------Form component----------any resson----->
      @if (resource && type == 'form') {
        <div>
          @if (resource.popup.form!='' && showDirect) {
            <dhs-form [action]="resource.popup.hasOwnProperty('action')?resource.popup.action:'ADD'"
              [formtype]="'popup'" [fieldGroup]="resource.popup.form" [config]="config"
              (saveFinished)="onSaveFinished($event,resource)" (cancel)="closePopup()">
            </dhs-form>
          }
          @if (resource.popup.form!='' && _currentData.currentFormFields  && showINDirect) {
            <dhs-form [action]="resource.popup.hasOwnProperty('action')?resource.popup.action:'ADD'"
              [formtype]="'popup'" [data]="currentData?currentData:{}" [fieldGroup]="_currentData.currentFormFields" [config]="config"
              (saveFinished)="onSaveFinished($event,resource)" (cancel)="closePopup()">
            </dhs-form>
          }
        </div>
      }
      @if (editableResource && type == 'EDIT_GRID') {
        <div>
          <kx-editable-grid [resourceName]="editableResource"> </kx-editable-grid>
        </div>
      }
      @if (editableResource && type == 'EDITGRID') {
        <div>
          <dhs-editable-grid [resource]="editableResource" (listen_changes)="listen_changes($event)"></dhs-editable-grid>
          <br>
            @if (this['data'] && this['data'].showbuttons) {
              <div class="text-center">
                <button type="button" class="primary-btn" (click)="showAllergy()">
                  Show allergy
                  <i aria-hidden="true" class="fa fa-eye"></i>
                </button>
              </div>
            }
          </div>
        }
        <!-- <div *ngIf="theHtmlString && type == 'htmlViewer'">
        <div [innerHTML]="theHtmlString"></div>
      </div> -->
      @if (theHtmlString && type === 'htmlViewer') {
        <div>
          <iframe #iframeElement id="cims" [srcdoc]="theHtmlString" style="width: 100%; height: 700px; border: none;"></iframe>
        </div>
      }

    </div>
  </div>
  <!-- <ng-template #imageviewer>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <ng-container>
        <div
          *ngIf="blobResp && (blobResp.type == 'image/jpeg' || blobResp.type == 'image/png' || blobResp.type == 'image/jpg' || blobResp.type == 'image/gif')">
          <app-image-viewer style="width: 100%; height:600px" [src]="imageSrc" [fileData]="fileData">
          </app-image-viewer>
        </div>
        <div *ngIf="pdfDocument && blobResp && blobResp.type == 'application/pdf'">
          <pdf-viewer [config]="pdfDocument" [isBlob]="true"></pdf-viewer>
        </div>
        <div *ngIf="blobResp && blobResp.type == 'text/plain'">
          <div>
            <div style="margin-bottom: 1rem; font-weight: bold;">
            {{textFile.document_name ? textFile.document_name : ''}}</div>
            <div>{{decodedText ? decodedText : ''}}</div>
          </div>
        </div>
        <div *ngIf="blobResp && blobResp.type == 'application/dicom' && imageUrl != ''">
          <diacom-viewer [config]="{url:imageUrl}"></diacom-viewer>
        </div>
      </ng-container>
      <div *ngIf="sideListData.length == 0 && imageSrc.length == 0 && !blobResp">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12 text-center my-auto">
          <div class="card card-block d-flex" style="height: 120px">
            <div class="card-body align-items-center d-flex justify-content-center font-xl">
              No Documents Found
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template> -->